import { Quote, Star } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Stagger, StaggerItem } from "@/components/motion/Reveal";
import { TESTIMONIALS } from "@/data/content";

const initials = (name) =>
  name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

export const Testimonials = ({ limit }) => {
  const list = limit ? TESTIMONIALS.slice(0, limit) : TESTIMONIALS;
  return (
    <section className="py-20 lg:py-28 bg-white" data-testid="testimonials-section">
      <div className="container-x">
        <SectionHeading
          eyebrow="In Their Own Words"
          title={<>Real customers. Real moments. <span className="text-brand-red">No scripts.</span></>}
          sub="Composite stories built from real letters, emails and calls — names and details changed for privacy."
        />

        <Stagger className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" gap={0.1}>
          {list.map((t, i) => (
            <StaggerItem key={i}>
              <figure
                data-testid={`testimonial-${i}`}
                className="h-full flex flex-col rounded-3xl bg-brand-bg border border-brand-line p-7 hover:border-brand-navy/30 hover:shadow-card transition-all duration-300"
              >
                <div className="flex items-center justify-between">
                  <Quote className="w-9 h-9 text-brand-red/30" strokeWidth={2} />
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} className="w-4 h-4 fill-brand-red text-brand-red" />
                    ))}
                  </div>
                </div>
                <blockquote className="mt-4 flex-1 text-brand-navy leading-relaxed text-[17px]">
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-6 pt-5 border-t border-brand-line flex items-center gap-3">
                  <span className="grid place-items-center w-11 h-11 rounded-full bg-brand-navy text-white font-display font-bold text-sm">
                    {initials(t.name)}
                  </span>
                  <div>
                    <p className="font-bold text-brand-navy leading-tight">{t.name}</p>
                    <p className="text-sm text-brand-ink2">
                      {t.location} · {t.context}
                    </p>
                  </div>
                </figcaption>
              </figure>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
